import React from 'react';
import { useSelector } from 'react-redux';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { TcsmStates } from '../../../../../../root/tcsm-model';
import { NewHireProps } from '../../../../models/arc-epi-props';
import { DividerSection } from '../../../../../../../stories/divider-section';
import { getLetterMonthDate } from '../../../../../../global/helpers/date-helpers';
import { PageHeader } from '../../../../../../global/components/layout/page-header';
import { PensionEnrollmentInfo, PensionEnrollmentPlan } from '../../../pension-enrollment/models/pension-enrollment-model';
import { useMemberPensionEnrollmentInfo } from '../hooks/useMemberPensionEnrollmentInfo';
import { ContentSpacer } from '../../../../../../global/components/layout/generic-content-spacer';
import { LabelAndValue } from '../../../../../../global/components/data-display/label-value';
import { WysiwygWithReactLink } from '../../../../../../global/components/wysiwyg-with-react-link';

export function MemberRetirementPlansDisplay() {

	const newHirePropsLoaded = useSelector<TcsmStates, boolean>(state => state?.epiProps?.newHireSettingsState?.contentLoaded);
	const newHireProps = useSelector<TcsmStates, NewHireProps>(state => state?.epiProps?.newHireSettingsState?.epiContent);

	const memberCurrentEmployerName = useSelector<TcsmStates, string>(state => state?.newHireEnrollmentState?.memberCurrentEmployer?.name);

	const memberPensionEnrollmentInfo = useSelector<TcsmStates, PensionEnrollmentInfo>(state => state?.newHireEnrollmentState?.memberPensionInfo);
	const memberPensionEnrollmentInfoLoaded = useMemberPensionEnrollmentInfo();
	const enrolledPlans = memberPensionEnrollmentInfo?.enrolled_plans;


	if (!memberPensionEnrollmentInfoLoaded || !memberPensionEnrollmentInfo || !newHirePropsLoaded) {
		return <LoadingCircle />;
	}

	function RenderContribution(enrolledPlan: PensionEnrollmentPlan) {
		if (!enrolledPlan?.employee_contribution) return null;

		return (
			<ContentSpacer>
				<p><strong>{newHireProps?.contributionLabel}</strong></p>
				<p>{enrolledPlan?.employee_contribution}</p>
			</ContentSpacer>
		);
	}

	function RenderEmployerContributions(enrolledPlan: PensionEnrollmentPlan) {
		if (!enrolledPlan?.employer_base && !enrolledPlan?.employer_match) return null;

		return (
			<>
				<LabelAndValue label={newHireProps?.employerBaseContributionLabel} tooltipMessage={newHireProps?.employerBaseContributionHelperText} value={enrolledPlan?.employer_base || 0} />
				<LabelAndValue label={newHireProps?.employerMatchContributionLabel} tooltipMessage={newHireProps?.employerMatchContributionHelperText} value={enrolledPlan?.employer_match || 0} />
			</>
		);
	}

	return (
		<>
			{
				memberPensionEnrollmentInfo &&
				<>
					<PageHeader headerText={newHireProps?.retirementEnrollmentTitle} />
					<DividerSection>
						{
							enrolledPlans?.length > 0 ?
								enrolledPlans?.map(enrolledPlan => {
									return (
										<ContentSpacer>
											<ContentSpacer>
												<h3>{enrolledPlan?.product?.description} - {enrolledPlan?.plan_id}</h3>
												<div>{memberCurrentEmployerName}</div>
											</ContentSpacer>
											{RenderContribution(enrolledPlan)}
											{RenderEmployerContributions(enrolledPlan)}
											<ContentSpacer>
												<p><strong>{newHireProps?.effectiveDateLabel}</strong></p>
												<p>{getLetterMonthDate(enrolledPlan?.enrollment_effective_date)}</p>
											</ContentSpacer>
										</ContentSpacer>
									);
								}) :
								<WysiwygWithReactLink content={newHireProps?.noAvailablePlanMessage} />
						}
					</DividerSection>
				</>
			}
		</>
	);
}